import styled from 'styled-components'

export const PoolListAccordionContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const PoolListAccordionListItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0 16px 0;
  border-radius: 12px;
  cursor: pointer;

  @media (max-width: 768px) {
    padding: 8px;
  }
  transition: all 300ms;
  &:hover {
    background: ${({ theme }) => theme.bg2};
  }
  background: ${({ theme }) => theme.bg1};

  .title {
    width: 250px;
    min-width: 250px;
    margin-left: 30px;
  }
  h3 {
    font-family: 'Unbounded';
    font-size: 14px;
    font-weight: 600;
    margin: 0;
    color: ${({ theme }) => theme.text2};
    @media (max-width: 768px) {
      font-size: 12px;
      font-weight: 400;
    }
  }

  .wrapper-infos {
    position: relative;
    display: flex;
    align-items: center;
    flex: 1;
    font-size: 14px;
    color: ${({ theme }) => theme.text2};
    .apr {
      min-width: 12%;
    }
    .daily-fees {
      min-width: 12%;
    }
    .tvl {
      min-width: 17.5%;
    }
    .volume {
      min-width: 17.5%;
    }
    .reserve {
      min-width: 32%;
    }
    .btn {
      min-width: 9%;
    }
  }
`

export const PoolListAccordionButton = styled.button`
  all: unset;
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
  padding-right: 16px;
  align-items: center;

  svg {
    margin-right: 16px;
  }
`

export const PoolListAccordionDetailsList = styled.div<{ isOpen: boolean }>`
  overflow: hidden;
  transition: max-height 300ms ease-in-out;
  max-height: ${({ isOpen }) => (isOpen ? '2000px' : '0')};
  display: flex;
  flex-direction: column;
`

export const PoolListAccordionListItemDetail = styled.div`
  display: flex;
  padding: 16px 0;
  border-bottom: 1px solid ${({ theme }) => theme.text3};

  flex-direction: column;
  gap: 16px;

  .poollist-infos {
    flex-wrap: wrap;
    gap: 18px;

    div {
      width: unset !important;
    }
  }

  &:last-child {
    padding: 16px 0 0 0;
    border-bottom: 0;
  }

  .poollist-header {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 250px;
    margin-left: 30px;
  }

  .poollist-infos {
    display: flex;

    flex: 1;
    align-items: center;

    .pool-list-infos-apr {
      min-width: 12%;
    }
    .pool-list-infos-fee {
      min-width: 12%;
    }
    .pool-list-infos-tvl {
      min-width: 17.5%;
    }
    .pool-list-infos-volume {
      min-width: 17.5%;
    }
    .pool-list-infos-reserve {
      min-width: 32%;
    }
    .pool-list-infos-btn {
      min-width: 9%;
    }
  }
`
